"use strict";
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkOrderCommentApi = exports.WorkOrderCommentApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
// @ts-ignore
const models_1 = require("../models");
/**
 * WorkOrderCommentApi - axios parameter creator
 * @export
 */
const WorkOrderCommentApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} workOrderId
         * @param {ICommentEntity} iCommentEntity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addWorkOrderComment: async (workOrderId, iCommentEntity, options = {}) => {
            // verify required parameter 'workOrderId' is not null or undefined
            (0, common_1.assertParamExists)('addWorkOrderComment', 'workOrderId', workOrderId);
            // verify required parameter 'iCommentEntity' is not null or undefined
            (0, common_1.assertParamExists)('addWorkOrderComment', 'iCommentEntity', iCommentEntity);
            const localVarPath = `/api/work-order/comment/add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (workOrderId !== undefined) {
                localVarQueryParameter['work_order_id'] = workOrderId;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCommentEntity, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} workOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkOrderComments: async (workOrderId, options = {}) => {
            // verify required parameter 'workOrderId' is not null or undefined
            (0, common_1.assertParamExists)('listWorkOrderComments', 'workOrderId', workOrderId);
            const localVarPath = `/api/work-order/comment/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (workOrderId !== undefined) {
                localVarQueryParameter['work_order_id'] = workOrderId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.WorkOrderCommentApiAxiosParamCreator = WorkOrderCommentApiAxiosParamCreator;
/**
 * WorkOrderCommentApi -
 */
var WorkOrderCommentApi;
(function (WorkOrderCommentApi) {
    /**
     *
     * @param {number} workOrderId
     * @param {ICommentEntity} iCommentEntity
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof WorkOrderCommentApi
     * url /api/work-order/comment/add
     */
    async function addWorkOrderComment(workOrderId, iCommentEntity, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.WorkOrderCommentApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.addWorkOrderComment(workOrderId, iCommentEntity, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_1.parseICommentEntity)(res.data);
            return res;
        });
    }
    WorkOrderCommentApi.addWorkOrderComment = addWorkOrderComment;
    /**
     *
     * @param {number} workOrderId
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof WorkOrderCommentApi
     * url /api/work-order/comment/list
     */
    async function listWorkOrderComments(workOrderId, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.WorkOrderCommentApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.listWorkOrderComments(workOrderId, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = res.data.map((x) => (0, models_1.parseICommentEntity)(x));
            return res;
        });
    }
    WorkOrderCommentApi.listWorkOrderComments = listWorkOrderComments;
})(WorkOrderCommentApi || (exports.WorkOrderCommentApi = WorkOrderCommentApi = {}));
